document.addEventListener('DOMContentLoaded', () => {
  // Get the target element
  const targetElement = document.getElementById('read-more');
  // Ensure the target element exists
  if (targetElement) {
    // Add a click event listener to the "read-more" link
    const readMoreLink = document.getElementById('read-more-link');
    
  // Ensure the read-more link exists
  if (readMoreLink) {
      readMoreLink.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent the default anchor link behavior
        
        // Scroll to the target element smoothly
        targetElement.scrollIntoView({ behavior: 'smooth' });
      });
  } else {
    }
  } 
  
  else {
  }
});
